<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()" novalidate>
  <crm-alert #alert></crm-alert>
  <div class="form-group">
    <label>{{client?.IS_BANK ? 'Client Name' : 'Bank Name' }}</label>
    <input type="text" name="COMPANY_NAME" [(ngModel)]="client.COMPANY_NAME" #COMPANY_NAME="ngModel" class="form-control rounded-0"
      [ngClass]="{ 'is-invalid': f.submitted && COMPANY_NAME.invalid}" required maxlength="150">
    <div *ngIf="f.submitted && COMPANY_NAME.invalid" class="invalid-feedback">
      <div *ngIf="COMPANY_NAME.errors.required">Field is required</div>
    </div>
  </div>

  <ng-container *ngIf="client?.IS_BANK || (!compact && !editFlag)">

    <div class="form-group">
      <label>Address</label>
      <input type="text" name="ADDRESS" [(ngModel)]="client.ADDRESS" #ADDRESS="ngModel" class="form-control rounded-0" maxlength="100">
    </div>

    <div class="form-group">
      <label>Address2</label>
      <input type="text" name="ADDRESS2" [(ngModel)]="client.ADDRESS2" class="form-control rounded-0" maxlength="100">
    </div>

    <div class="form-row">
      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label>Zip</label>
        <input type="text" maxlength="5" [(ngModel)]="client.ZIP" name="ZIP" class="form-control rounded-0"
          #ZIP="ngModel" (keyup)="zipKeyUp()" (keypress)="zipKeyPress($event)">
        <div *ngIf="zipError" class="invalid-feedback">
          {{zipError}}
        </div>
      </div>

      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label>State</label>
        <input-search [preset]="stateItems" name="STATE" [(ngModel)]="client.STATE"
          [regular]="true" [searchable]="true" #STATE="ngModel"
          (valueChange)="processPresetValue($event)" placeholder="Select State"></input-search>
      </div>
    </div>

    <div class="form-group">
      <label>City</label>
      <input type="text" name="CITY" [(ngModel)]="client.CITY" class="form-control rounded-0" #CITY="ngModel" maxlength="50">
    </div>

    <div class="form-row">
      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label>Phone</label>
        <input type="text" name="PHONE" [(ngModel)]="client.PHONE" class="form-control rounded-0" mask='(000) 000-0000' maxlength="14" placeholder="(000)-000-0000">
      </div>
      <div class="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <label>Phone Ext</label>
        <input type="text" name="PHONE_EXT" [(ngModel)]="client.PHONE_EXT" class="form-control rounded-0" numbersOnly maxlength="5" placeholder="000">
      </div>
    </div>

      <div class="form-group">
      <label>Fax</label>
      <input type="text" name="FAX" [(ngModel)]="client.FAX" class="form-control rounded-0" maxlength="14" mask='(000) 000-0000'
        placeholder="(000)-000-0000">
     </div>

    <div class="form-group">
      <label>Web</label>
      <input type="text" name="WEB" [(ngModel)]="client.WEB" class="form-control rounded-0" #WEB="ngModel" maxlength="100">
    </div>
  </ng-container>

  <div class="form-group">
    <label>Domains <span style="font-weight: 200;font-size: 11px;font-style: italic;">(coma separated)</span></label>
    <input type="text" name="DOMAINS" [(ngModel)]="client.DOMAINS" #DOMAINS="ngModel" class="form-control rounded-0"
           [ngClass]="{ 'is-invalid': f.submitted && DOMAINS.invalid }">
  </div>

   <div class="form-group">
     <label>Template</label>
     <input-search placeholder="Select Type of Template" [regular]="true"
       [preset]="templateValues" [inputValue]="client.TEMPLATE"
       (valueChange)="templateTypeChanged($event)"></input-search>
   </div>

  <div class="form-group">
    <label>Notes</label>
    <textarea class="form-control rounded-0" rows="3" name="NOTES" [(ngModel)]="client.NOTES"></textarea>
  </div>


  <div class="actions horizontal wrap right">
    <div class="left-actions" style="float: left;">
      <div class="checkbox-item">
        <input class="checkbox-custom" type='checkbox' name="isBank" id="isBankField"
               [(ngModel)]="client.IS_BANK" [checked]="client.IS_BANK === true" />
        <label class="checkbox-custom-label" for="isBankField">Client is Non-Bank</label>
      </div>
    </div>

    <div class="left-actions" style="float: left; margin-left: 10px;">
      <div class="checkbox-item">
        <input class="checkbox-custom" type='checkbox' name="isLsp" id="isLSPField" [(ngModel)]="client.IS_LSP"
          [checked]="client.IS_LSP === true" />
        <label class="checkbox-custom-label" for="isLSPField">Client is LSP</label>
      </div>
    </div>

    <button type="button" class="btn btn-rbv default" (click)="actionCancel()">Cancel</button>
    <button type="submit" class="btn btn-rbv">Accept</button>
  </div>
</form>
